import { motion } from "framer-motion";
import { Globe, Code, Rocket, Link } from "@phosphor-icons/react";

export const WebsiteList = ({ websites, selectedWebsite, onSelectWebsite }) => {
  return (
    <div className="w-1/3 border-r border-border overflow-y-auto p-4" data-testid="websites-list">
      <h3 className="text-sm font-semibold mb-3 uppercase tracking-wider text-muted-foreground">
        Your Websites ({websites.length})
      </h3>
      {websites.length === 0 ? (
        <div className="text-center py-12">
          <Globe size={48} className="mx-auto mb-3 text-muted-foreground" />
          <p className="text-sm text-muted-foreground">No websites yet</p>
        </div>
      ) : (
        <div className="space-y-2">
          {websites.map((site) => (
            <motion.div
              key={site.id}
              onClick={() => onSelectWebsite(site)}
              className={`p-3 border cursor-pointer transition-all ${
                selectedWebsite?.id === site.id
                  ? "border-white bg-secondary"
                  : "border-border hover:border-white/40"
              }`}
              data-testid={`website-item-${site.id}`}
            >
              <div className="flex items-start gap-2">
                {site.deployed ? (
                  <Rocket size={24} className="text-green-500" />
                ) : (
                  <Code size={24} className="text-yellow-500" />
                )}
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate">{site.name}</p>
                  <p className="text-xs text-muted-foreground line-clamp-2">
                    {site.description}
                  </p>
                  {site.deployed && (
                    <div className="flex items-center gap-1 mt-1">
                      <Link size={12} className="text-green-500" />
                      <span className="text-xs text-green-500">Live</span>
                    </div>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
};
